module.exports = __webpack_public_path__ + "static/img/9.9199664.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shlzy/9.png
// module id = bXJ8
// module chunks = 0